module.exports = __webpack_public_path__ + "static/media/recent-user-1.a4d3469b.png";